declare global {
  interface Number {
    formatDistance(): string;
    formatFileSize(): string;
  }
}

Number.prototype.formatDistance = function (this: number) {
  return this >= 1
    ? this.toFixed(2) + ' M'
    : (this * 100).toFixed(1) + ' CM';
};

Number.prototype.formatFileSize = function (this: number) {
  if (this === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(this) / Math.log(k));
  return (this / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
};

export { };
